<div class="driver-modal">
  <div class="dialog-header">
    <h1 class="dialog-title">{{ 'Filter' | translate }}</h1>
    <div *ngIf="hasActiveFilters" class="active-filter-badge">
      {{ 'Active Filters' | translate }}
    </div>
  </div>

  <div class="modal-content">
    <form [formGroup]="filterForm">
      <ng-container *ngIf="dataArray && dataArray.length">
        <ng-container *ngFor="let item of dataArray">
          <div class="filter-group">
            <div class="filter-header">
              <h2>{{ item[0] | translate }}</h2>
              <span *ngIf="item[0] === 'brands' && filterForm.get('brands')?.value?.length" class="filter-count">
                ({{ filterForm.get('brands')?.value?.length }} {{ 'selected' | translate }})
              </span>
              <span *ngIf="item[0] === 'categories' && filterForm.get('categories')?.value?.length" class="filter-count">
                ({{ filterForm.get('categories')?.value?.length }} {{ 'selected' | translate }})
              </span>
            </div>
            <div class="filter-body">
              <ng-container *ngIf="item[0] === 'brands'">
                <mat-form-field appearance="fill">
                  <mat-label>{{ 'Select Brands' | translate }}</mat-label>
                  <mat-select
                    multiple
                    formControlName="brands"
                  >
                    <mat-option *ngFor="let brand of getBrandsFromItem(item)" [value]="brand._id">
                      {{ brand.name }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </ng-container>
              <ng-container *ngIf="item[0] === 'categories'">
                <mat-form-field appearance="fill">
                  <mat-label>{{ 'Select Categories' | translate }}</mat-label>
                  <mat-select
                    multiple
                    formControlName="categories"
                  >
                    <mat-option *ngFor="let category of categories" [value]="category._id">
                      {{ category.name }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </ng-container>
            </div>
          </div>
        </ng-container>
      </ng-container>
    </form>
  </div>
  
  <div class="modal-footer">
    <button (click)="clearFilters()" class="btnn btn_secondary">
      {{ 'Clear' | translate }}
    </button>
    <button (click)="cancelDialog()" class="btnn btn_light">
      {{ 'Cancel' | translate }}
    </button>
    <button (click)="applyFilters()" class="btnn btn_primary">
      {{ 'Apply' | translate }}
    </button>
  </div>
</div>
